/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { StatusContext } from 'src/components/status-store';
import React, { MouseEvent } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import Logo from '@domain-group/fe-co-domain-group-logo';
import CloseIcon from '@domain-group/fe-co-icon/lib/js/close';
import MenuIcon from '@domain-group/fe-co-icon/lib/js/menu';
import AgentIcon from '@domain-group/fe-co-icon/lib/js/agent';
import MarketArrowDownIcon from '@domain-group/fe-co-icon/lib/js/market-arrow-down';
import { LinkButton } from '@domain-group/fe-co-button';
import Link from 'next/link';
import * as gtag from 'src/lib/gtag';
import * as styles from './header.styles';
import LoggedInMenu from './logged-in-dropdown';

interface HeaderState {
  navigationOpen: boolean;
  dropdownActive: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface HeaderProps {}

export default class Header extends React.Component<HeaderProps, HeaderState> {
  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      navigationOpen: false,
      dropdownActive: false,
    };
  }

  // nav is mobile hamburger nav
  toggleNav = (): void => {
    this.setState((prevState) => ({
      navigationOpen: !prevState.navigationOpen,
    }));
  };

  closeNav = (): void => {
    this.setState({ navigationOpen: false });
  };

  // dropdwon is the member dropdown
  toggleDropdownContent = (event: MouseEvent): void => {
    event.preventDefault();
    this.setState((prevState) => ({
      dropdownActive: !prevState.dropdownActive,
    }));
  };

  closeOpenDropdown = (): void => {
    this.setState({ dropdownActive: false });
  };

  render(): React.ReactNode {
    return (
      <StatusContext.Consumer>
        {(statusContext) => (
          <div css={styles.headerContainer}>
            <div css={styles.header}>
              <div
                css={styles.mobileOverlay(this.state.navigationOpen)}
                onClick={this.toggleNav}
              />
              <div css={styles.logoContainer}>
                <Link prefetch={false} passHref href="/">
                  <a css={styles.logo} title="Domain Logo">
                    <Logo primaryFill="green" secondaryFill="navy" />
                  </a>
                </Link>
                <span css={styles.logoSubHead}>Developer Portal</span>
              </div>

              <nav
                id="main-menu"
                css={styles.headerNavigation(this.state.navigationOpen)}
                onClick={this.closeNav}
              >
                <ul css={styles.navigationList}>
                  <li>
                    <button
                      css={styles.toggleAndClose}
                      onClick={this.closeNav}
                      type="button"
                    >
                      <span css={styles.headerSrOnly}>Close navigation</span>
                      <CloseIcon size="custom" />
                    </button>
                  </li>
                  <li>
                    <Link prefetch={false} passHref href="/docs/latest/">
                      <a title="Documentation" css={styles.navigationItemLink}>
                        Documentation
                      </a>
                    </Link>
                  </li>
                  {statusContext.status?.isAuthenticated && (
                    <>
                      <li>
                        <a css={styles.navigationItemLink} href="/projects/">
                          Projects
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </nav>

              <div css={styles.ctaButton}>
                {statusContext.status?.isAuthenticated ? (
                  <OutsideClickHandler onOutsideClick={this.closeOpenDropdown}>
                    <div>
                      <button
                        css={[styles.member, styles.textButton]}
                        onClick={this.toggleDropdownContent}
                        type="button"
                      >
                        <AgentIcon
                          size="custom"
                          css={styles.memberAvatarIcon}
                        />
                        <div css={styles.memberEmail}>
                          {statusContext.status?.developerName}
                        </div>
                        <MarketArrowDownIcon
                          size="custom"
                          css={styles.memberArrowIcon}
                        />
                      </button>
                      {statusContext.status?.isAuthenticated && (
                        <LoggedInMenu
                          dropdownActive={this.state.dropdownActive}
                        />
                      )}
                    </div>
                  </OutsideClickHandler>
                ) : (
                  <>
                    <LinkButton
                      appearance="outline"
                      href="/account/login"
                      css={styles.loginButton}
                      rel="nofollow"
                      onClick={() =>
                        gtag.event({
                          category: 'engagement',
                          action: 'login',
                          label: 'header_login_desktop',
                        })
                      }
                    >
                      Log in
                    </LinkButton>
                    <LinkButton
                      appearance="outline"
                      href="/account/login"
                      size="small"
                      css={styles.loginButtonMobile}
                      rel="nofollow"
                      onClick={() =>
                        gtag.event({
                          category: 'engagement',
                          action: 'login',
                          label: 'header_login_mobile',
                        })
                      }
                    >
                      Log in
                    </LinkButton>
                    <LinkButton
                      appearance="regular"
                      href="/account/login"
                      onClick={() => gtag.tryButtonClick('header_try_button')}
                      css={styles.getStartedButton}
                    >
                      Get started
                    </LinkButton>
                  </>
                )}
              </div>

              <button
                css={styles.toggleAndClose}
                onClick={this.toggleNav}
                type="button"
              >
                <span css={styles.headerSrOnly}>Navigation</span>
                <MenuIcon size="custom" />
              </button>
            </div>
          </div>
        )}
      </StatusContext.Consumer>
    );
  }
}
